export const brand = {
  brand1: "19.32% 0.026 254.00",
  brand2: "21.30% 0.030 254.00",
  brand3: "27.41% 0.067 254.00",
  brand4: "31.70% 0.100 254.00",
  brand5: "36.49% 0.108 254.00",
  brand6: "41.61% 0.112 254.00",
  brand7: "47.48% 0.121 254.00",
  brand8: "54.13% 0.140 254.00",
  brand9: "75.93% 0.180 254.00",
  brand10: "80.90% 0.160 254.00",
  brand11: "85.79% 0.135 254.00",
  brand12: "90.72% 0.051 254.00",
};

export const gray = {
  gray1: "17.80% 0.000 0",
  gray2: "21.34% 0.000 89.88",
  gray3: "25.37% 0.000 89.88",
  gray4: "28.32% 0.000 89.88",
  gray5: "31.30% 0.000 89.88",
  gray6: "34.90% 0.000 89.88",
  gray7: "40.23% 0.000 0",
  gray8: "48.77% 0.000 89.88",
  gray9: "53.79% 0.000 89.88",
  gray10: "58.43% 0.000 89.88",
  gray11: "77.00% 0.000 89.88",
  gray12: "94.89% 0.000 0",
};

export const mauve = {
  mauve1: "17.99% 0.004 307.79",
  mauve2: "21.52% 0.004 307.84",
  mauve3: "25.50% 0.006 306.48",
  mauve4: "28.45% 0.008 307.75",
  mauve5: "31.38% 0.009 306.95",
  mauve6: "35.01% 0.010 303.98",
  mauve7: "40.16% 0.012 304.45",
  mauve8: "49.19% 0.016 300.74",
  mauve9: "54.05% 0.017 293.97",
  mauve10: "58.62% 0.017 295.36",
  mauve11: "76.98% 0.014 296.61",
  mauve12: "94.94% 0.003 286.35",
};

export const slate = {
  slate1: "17.89% 0.004 285.99",
  slate2: "21.33% 0.004 264.41",
  slate3: "25.34% 0.006 261.19",
  slate4: "28.27% 0.007 259.52",
  slate5: "31.14% 0.008 259.73",
  slate6: "34.59% 0.010 256.52",
  slate7: "39.77% 0.012 253.77",
  slate8: "48.99% 0.016 247.63",
  slate9: "53.70% 0.015 261.15",
  slate10: "58.30% 0.014 263.32",
  slate11: "76.77% 0.010 261.27",
  slate12: "94.88% 0.003 264.57",
};

export const sage = {
  sage1: "17.92% 0.004 167.38",
  sage2: "21.11% 0.004 160.17",
  sage3: "25.12% 0.004 164.20",
  sage4: "28.12% 0.005 164.87",
  sage5: "31.07% 0.005 167.44",
  sage6: "34.71% 0.006 167.42",
  sage7: "39.92% 0.008 167.38",
  sage8: "48.82% 0.009 169.81",
  sage9: "53.29% 0.018 170.77",
  sage10: "57.93% 0.016 170.51",
  sage11: "76.60% 0.010 167.51",
  sage12: "94.73% 0.002 167.70",
};

export const olive = {
  olive1: "17.97% 0.004 128.34",
  olive2: "21.17% 0.004 128.29",
  olive3: "25.16% 0.005 129.01",
  olive4: "28.07% 0.006 131.44",
  olive5: "31.01% 0.007 131.45",
  olive6: "34.64% 0.008 134.43",
  olive7: "39.86% 0.010 136.03",
  olive8: "48.77% 0.012 140.78",
  olive9: "53.52% 0.018 139.61",
  olive10: "58.12% 0.016 140.06",
  olive11: "76.59% 0.013 139.50",
  olive12: "94.70% 0.003 144.76",
};

export const sand = {
  sand1: "17.76% 0.002 106.63",
  sand2: "21.29% 0.002 106.58",
  sand3: "25.31% 0.003 106.62",
  sand4: "28.28% 0.004 99.02",
  sand5: "31.24% 0.004 100.73",
  sand6: "34.91% 0.006 102.24",
  sand7: "40.07% 0.007 96.10",
  sand8: "49.01% 0.010 91.73",
  sand9: "53.46% 0.011 94.07",
  sand10: "58.11% 0.011 94.05",
  sand11: "76.66% 0.009 97.38",
  sand12: "94.83% 0.003 106.45",
};

export const tomato = {
  tomato1: "18.69% 0.012 19.59",
  tomato2: "20.77% 0.017 32.02",
  tomato3: "25.37% 0.054 26.94",
  tomato4: "29.11% 0.087 28.17",
  tomato5: "33.14% 0.097 28.66",
  tomato6: "38.01% 0.099 30.01",
  tomato7: "44.74% 0.107 31.46",
  tomato8: "53.78% 0.130 32.94",
  tomato9: "62.70% 0.194 33.31",
  tomato10: "66.50% 0.179 34.15",
  tomato11: "78.43% 0.164 36.02",
  tomato12: "89.86% 0.047 31.11",
};

export const red = {
  red1: "18.80% 0.013 19.39",
  red2: "20.48% 0.022 14.74",
  red3: "25.04% 0.064 13.11",
  red4: "28.88% 0.096 14.29",
  red5: "33.16% 0.107 15.53",
  red6: "38.26% 0.111 16.93",
  red7: "45.06% 0.121 18.91",
  red8: "54.36% 0.147 21.44",
  red9: "62.54% 0.193 22.98",
  red10: "66.46% 0.177 23.09",
  red11: "78.37% 0.162 22.29",
  red12: "90.22% 0.053 6.14",
};

export const ruby = {
  ruby1: "18.88% 0.014 2.90",
  ruby2: "20.77% 0.016 5.29",
  ruby3: "25.38% 0.060 6.54",
  ruby4: "29.21% 0.089 5.50",
  ruby5: "33.27% 0.100 6.40",
  ruby6: "38.20% 0.105 7.59",
  ruby7: "44.83% 0.117 9.02",
  ruby8: "54.38% 0.145 11.06",
  ruby9: "62.84% 0.195 13.19",
  ruby10: "66.35% 0.179 13.69",
  ruby11: "78.61% 0.161 17.01",
  ruby12: "90.54% 0.053 355.83",
};

export const crimson = {
  crimson1: "18.93% 0.014 354.17",
  crimson2: "20.68% 0.022 352.90",
  crimson3: "25.57% 0.059 353.88",
  crimson4: "29.31% 0.094 354.06",
  crimson5: "33.26% 0.104 354.75",
  crimson6: "38.18% 0.109 355.49",
  crimson7: "45.01% 0.120 356.71",
  crimson8: "54.19% 0.148 358.34",
  crimson9: "63.43% 0.213 1.30",
  crimson10: "66.37% 0.197 1.95",
  crimson11: "78.74% 0.167 6.72",
  crimson12: "90.88% 0.054 346.66",
};

export const pink = {
  pink1: "19.07% 0.017 334.93",
  pink2: "20.74% 0.031 338.17",
  pink3: "26.14% 0.061 337.46",
  pink4: "29.94% 0.098 340.14",
  pink5: "33.80% 0.104 340.64",
  pink6: "38.90% 0.107 341.55",
  pink7: "45.87% 0.119 342.62",
  pink8: "54.54% 0.145 344.11",
  pink9: "61.67% 0.208 346.05",
  pink10: "65.00% 0.197 346.18",
  pink11: "78.87% 0.190 350.74",
  pink12: "90.53% 0.059 343.23",
};

export const plum = {
  plum1: "19.00% 0.017 326.98",
  plum2: "21.00% 0.031 327.68",
  plum3: "26.57% 0.062 326.67",
  plum4: "30.65% 0.088 325.27",
  plum5: "34.34% 0.095 324.63",
  plum6: "38.89% 0.097 324.20",
  plum7: "45.65% 0.106 323.43",
  plum8: "54.51% 0.128 322.16",
  plum9: "57.89% 0.188 322.09",
  plum10: "61.60% 0.182 322.12",
  plum11: "78.59% 0.154 322.06",
  plum12: "90.62% 0.055 325.83",
};

export const purple = {
  purple1: "19.15% 0.022 315.98",
  purple2: "21.31% 0.031 314.34",
  purple3: "26.63% 0.062 312.03",
  purple4: "30.82% 0.083 310.65",
  purple5: "34.45% 0.091 310.13",
  purple6: "38.77% 0.097 309.66",
  purple7: "44.96% 0.108 308.73",
  purple8: "54.09% 0.133 307.07",
  purple9: "55.55% 0.183 305.88",
  purple10: "59.59% 0.177 306.35",
  purple11: "78.51% 0.156 307.90",
  purple12: "91.09% 0.049 310.95",
};

export const violet = {
  violet1: "19.14% 0.026 290.52",
  violet2: "21.13% 0.032 299.46",
  violet3: "27.09% 0.066 293.92",
  violet4: "31.21% 0.093 291.75",
  violet5: "34.84% 0.099 291.40",
  violet6: "38.97% 0.102 291.82",
  violet7: "44.46% 0.111 291.57",
  violet8: "51.63% 0.131 290.20",
  violet9: "54.18% 0.179 288.10",
  violet10: "58.82% 0.170 289.68",
  violet11: "77.82% 0.137 293.62",
  violet12: "91.16% 0.045 292.61",
};

export const iris = {
  iris1: "19.28% 0.022 284.19",
  iris2: "20.85% 0.029 286.54",
  iris3: "27.28% 0.069 278.58",
  iris4: "31.88% 0.102 276.10",
  iris5: "35.81% 0.109 277.41",
  iris6: "39.88% 0.112 279.64",
  iris7: "44.80% 0.120 280.78",
  iris8: "50.73% 0.138 281.09",
  iris9: "54.03% 0.184 278.30",
  iris10: "58.67% 0.172 281.19",
  iris11: "77.57% 0.131 286.56",
  iris12: "91.42% 0.042 286.98",
};

export const indigo = {
  indigo1: "19.07% 0.025 276.72",
  indigo2: "20.88% 0.030 275.95",
  indigo3: "27.22% 0.069 267.84",
  indigo4: "31.90% 0.093 267.04",
  indigo5: "36.18% 0.105 267.50",
  indigo6: "40.37% 0.111 268.34",
  indigo7: "45.03% 0.120 268.80",
  indigo8: "50.27% 0.137 268.41",
  indigo9: "54.36% 0.191 267.08",
  indigo10: "58.99% 0.176 269.19",
  indigo11: "77.72% 0.123 273.28",
  indigo12: "91.10% 0.043 269.99",
};

export const blue = {
  blue1: "19.32% 0.026 256.79",
  blue2: "21.30% 0.030 258.84",
  blue3: "27.41% 0.067 253.96",
  blue4: "31.70% 0.100 248.30",
  blue5: "36.49% 0.108 249.72",
  blue6: "41.61% 0.112 251.66",
  blue7: "47.48% 0.121 252.84",
  blue8: "54.13% 0.140 253.21",
  blue9: "64.93% 0.193 251.81",
  blue10: "68.90% 0.170 251.46",
  blue11: "76.79% 0.135 248.84",
  blue12: "90.72% 0.051 238.27",
};

export const cyan = {
  cyan1: "19.13% 0.017 219.89",
  cyan2: "21.41% 0.018 225.41",
  cyan3: "27.22% 0.044 222.47",
  cyan4: "31.50% 0.063 222.14",
  cyan5: "36.17% 0.070 221.51",
  cyan6: "41.35% 0.075 221.73",
  cyan7: "47.77% 0.083 221.41",
  cyan8: "55.77% 0.098 220.71",
  cyan9: "66.09% 0.122 221.49",
  cyan10: "69.80% 0.120 219.12",
  cyan11: "78.56% 0.115 213.40",
  cyan12: "90.93% 0.057 211.73",
};

export const teal = {
  teal1: "18.89% 0.012 184.50",
  teal2: "21.65% 0.017 189.31",
  teal3: "27.37% 0.038 186.35",
  teal4: "31.73% 0.055 187.00",
  teal5: "36.25% 0.060 186.52",
  teal6: "41.37% 0.065 185.38",
  teal7: "47.32% 0.074 184.55",
  teal8: "53.89% 0.087 183.55",
  teal9: "64.88% 0.113 182.01",
  teal10: "68.69% 0.123 180.32",
  teal11: "78.88% 0.147 175.66",
  teal12: "90.51% 0.072 175.26",
};

export const jade = {
  jade1: "18.80% 0.014 166.30",
  jade2: "21.58% 0.018 166.11",
  jade3: "27.24% 0.042 166.82",
  jade4: "31.64% 0.057 168.02",
  jade5: "36.18% 0.064 168.52",
  jade6: "41.08% 0.068 169.69",
  jade7: "46.85% 0.075 170.64",
  jade8: "53.69% 0.088 171.80",
  jade9: "64.21% 0.115 170.85",
  jade10: "67.76% 0.125 169.87",
  jade11: "78.54% 0.156 167.10",
  jade12: "90.27% 0.078 166.98",
};

export const green = {
  green1: "18.88% 0.013 163.27",
  green2: "21.27% 0.016 162.22",
  green3: "27.14% 0.039 162.67",
  green4: "31.82% 0.057 161.54",
  green5: "36.48% 0.066 161.11",
  green6: "41.34% 0.073 160.73",
  green7: "46.74% 0.083 159.91",
  green8: "52.75% 0.096 159.19",
  green9: "64.05% 0.133 157.75",
  green10: "67.55% 0.141 157.56",
  green11: "77.97% 0.166 157.23",
  green12: "90.48% 0.083 158.28",
};

export const grass = {
  grass1: "18.83% 0.014 155.81",
  grass2: "21.10% 0.014 151.48",
  grass3: "26.71% 0.030 150.73",
  grass4: "31.91% 0.052 150.41",
  grass5: "36.68% 0.062 149.91",
  grass6: "41.64% 0.072 149.34",
  grass7: "46.83% 0.084 148.89",
  grass8: "52.38% 0.097 148.25",
  grass9: "65.16% 0.147 147.37",
  grass10: "68.98% 0.145 147.64",
  grass11: "77.98% 0.142 148.46",
  grass12: "91.10% 0.078 144.91",
};

export const brown = {
  brown1: "17.85% 0.005 81.55",
  brown2: "21.31% 0.007 51.62",
  brown3: "25.36% 0.013 53.48",
  brown4: "28.84% 0.018 55.42",
  brown5: "32.47% 0.024 55.88",
  brown6: "37.02% 0.032 57.69",
  brown7: "42.90% 0.041 59.84",
  brown8: "50.86% 0.053 62.17",
  brown9: "63.27% 0.078 60.77",
  brown10: "67.44% 0.075 61.48",
  brown11: "79.82% 0.063 62.51",
  brown12: "91.76% 0.036 75.67",
};

export const bronze = {
  bronze1: "18.06% 0.005 41.55",
  bronze2: "21.47% 0.005 41.54",
  bronze3: "25.45% 0.008 42.65",
  bronze4: "29.11% 0.010 45.50",
  bronze5: "32.94% 0.013 43.31",
  bronze6: "37.44% 0.016 44.26",
  bronze7: "42.99% 0.020 44.84",
  bronze8: "49.86% 0.024 45.17",
  bronze9: "62.75% 0.046 44.29",
  bronze10: "66.87% 0.045 44.29",
  bronze11: "79.18% 0.043 44.50",
  bronze12: "91.51% 0.017 50.30",
};

export const gold = {
  gold1: "18.22% 0.002 106.62",
  gold2: "21.65% 0.006 92.49",
  gold3: "25.49% 0.008 88.28",
  gold4: "29.08% 0.010 86.76",
  gold5: "32.89% 0.011 83.66",
  gold6: "37.36% 0.014 82.43",
  gold7: "42.94% 0.016 80.92",
  gold8: "49.83% 0.020 79.50",
  gold9: "62.06% 0.049 78.13",
  gold10: "66.22% 0.047 77.18",
  gold11: "79.40% 0.041 77.18",
  gold12: "91.51% 0.014 77.44",
};

export const sky = {
  sky1: "18.98% 0.024 257.09",
  sky2: "21.61% 0.029 258.45",
  sky3: "27.11% 0.054 251.88",
  sky4: "32.22% 0.070 247.75",
  sky5: "37.25% 0.079 245.75",
  sky6: "42.69% 0.087 243.56",
  sky7: "48.80% 0.098 240.69",
  sky8: "55.74% 0.114 237.22",
  sky9: "86.14% 0.103 217.81",
  sky10: "90.81% 0.073 214.92",
  sky11: "79.26% 0.099 231.67",
  sky12: "93.37% 0.053 214.37",
};

export const mint = {
  mint1: "18.84% 0.012 192.27",
  mint2: "21.01% 0.017 196.61",
  mint3: "26.87% 0.039 192.53",
  mint4: "31.35% 0.058 191.65",
  mint5: "35.94% 0.063 188.94",
  mint6: "41.04% 0.067 186.27",
  mint7: "47.09% 0.073 183.35",
  mint8: "54.01% 0.085 179.56",
  mint9: "86.96% 0.100 177.97",
  mint10: "91.62% 0.080 179.36",
  mint11: "79.55% 0.118 176.38",
  mint12: "93.05% 0.057 168.49",
};

export const lime = {
  lime1: "18.04% 0.014 120.26",
  lime2: "20.80% 0.019 128.97",
  lime3: "26.62% 0.034 132.18",
  lime4: "31.65% 0.047 131.83",
  lime5: "36.34% 0.058 131.64",
  lime6: "41.16% 0.069 131.40",
  lime7: "46.44% 0.080 131.16",
  lime8: "52.43% 0.095 130.86",
  lime9: "88.75% 0.175 126.09",
  lime10: "94.18% 0.175 123.73",
  lime11: "86.78% 0.156 124.78",
  lime12: "94.64% 0.082 122.62",
};

export const yellow = {
  yellow1: "18.11% 0.013 86.01",
  yellow2: "20.88% 0.017 92.09",
  yellow3: "25.90% 0.047 90.29",
  yellow4: "29.26% 0.069 94.20",
  yellow5: "33.34% 0.079 94.59",
  yellow6: "38.43% 0.077 93.30",
  yellow7: "45.16% 0.081 91.50",
  yellow8: "53.49% 0.095 89.93",
  yellow9: "92.66% 0.209 102.14",
  yellow10: "97.11% 0.182 109.36",
  yellow11: "90.02% 0.166 101.64",
  yellow12: "94.13% 0.075 101.04",
};

export const amber = {
  amber1: "18.36% 0.013 77.27",
  amber2: "21.17% 0.018 78.68",
  amber3: "25.75% 0.044 74.56",
  amber4: "29.62% 0.071 76.25",
  amber5: "33.69% 0.081 76.41",
  amber6: "38.71% 0.078 75.09",
  amber7: "45.32% 0.082 74.55",
  amber8: "53.60% 0.096 73.57",
  amber9: "85.62% 0.178 81.37",
  amber10: "90.15% 0.206 96.98",
  amber11: "87.06% 0.175 85.07",
  amber12: "93.49% 0.072 85.99",
};

export const orange = {
  orange1: "18.64% 0.012 53.75",
  orange2: "20.88% 0.019 67.38",
  orange3: "25.75% 0.045 59.54",
  orange4: "29.33% 0.080 58.65",
  orange5: "33.46% 0.087 58.09",
  orange6: "38.63% 0.087 55.15",
  orange7: "45.34% 0.095 53.06",
  orange8: "54.05% 0.116 49.75",
  orange9: "68.90% 0.191 44.80",
  orange10: "74.14% 0.199 46.32",
  orange11: "79.90% 0.163 50.77",
  orange12: "92.48% 0.052 66.22",
};
